import { render, staticRenderFns } from "./ShopifyOrderLink.vue?vue&type=template&id=3cb8802a&"
import script from "./ShopifyOrderLink.vue?vue&type=script&lang=js&"
export * from "./ShopifyOrderLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports